var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-checkbox',{attrs:{"input-value":_vm.data.header.type.getValue(_vm.data.item, _vm.data.header.type),"readonly":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }